import { Directive, ElementRef, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';

const ALLOWED_KEYS = [
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
];

@Directive({
  selector: '[ldNumericOnly]',
  host: {
    '(input)': 'onInput($event)',
    '(paste)': 'onPaste($event)',
    '(keydown)': 'onKeyDown($event)',
  },
})
export class NumericOnlyDirective {
  private readonly el = inject(ElementRef<HTMLInputElement>);
  private readonly ngControl = inject(NgControl, { optional: true });

  readonly blockPaste = input(false);

  protected onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const stripped = input.value.replace(/\D/g, '');
    if (input.value !== stripped) {
      input.value = stripped;
      this.ngControl?.control?.setValue(stripped, { emitEvent: false });
    }
  }

  protected onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    if (this.blockPaste()) {
      return;
    }
    const pastedText = event.clipboardData?.getData('text') || '';
    const stripped = pastedText.replace(/\D/g, '');
    const input = this.el.nativeElement;
    input.value = stripped;
    this.ngControl?.control?.setValue(stripped);
  }

  protected onKeyDown(event: KeyboardEvent): void {
    if (ALLOWED_KEYS.includes(event.key)) {
      return;
    }

    if (event.ctrlKey || event.metaKey) {
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
